import type { AnalyticsBrowser } from "@segment/analytics-next"
import { createContext } from "react"

export type SegmentContextValue = React.MutableRefObject<AnalyticsBrowser>

type ContextType = SegmentContextValue | null

export const SegmentContext = createContext<ContextType>(null)
